"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextHero = TextHero;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
var _gridItem = _interopRequireDefault(require("../../fuse-responsive-grid/src/grid-item"));
var _typography = require("../../fuse-typography-element/src/typography");
var _excluded = ["text", "dataTestId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var StyledTypographyComponent = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  displayName: "text-hero__StyledTypographyComponent",
  componentId: "sc-17gfyga-0"
})(["text-align:center;padding:var(--spacing-global-space10) 0;text-overflow:ellipsis;overflow:hidden;@media screen and (min-width:", "){padding:var(--spacing-global-space12) 0;}"], _grid.gridConfig.l.minWidth);
var StyledGridContainer = (0, _styledComponents["default"])(_grid.GridContainer).attrs({
  className: 'fuse-text-hero'
}).withConfig({
  displayName: "text-hero__StyledGridContainer",
  componentId: "sc-17gfyga-1"
})(["background-color:var(--color-brand-light);"]);
var propTypes = {
  text: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};
var defaultProps = {
  text: null,
  dataTestId: undefined
};
function TextHero(_ref) {
  var text = _ref.text,
    dataTestId = _ref.dataTestId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledGridContainer, _extends({
    "data-testid": dataTestId
  }, props), /*#__PURE__*/_react["default"].createElement(_grid.GridRow, null, /*#__PURE__*/_react["default"].createElement(_gridItem["default"], {
    xxs: "12",
    m: "10",
    "colStart-m": "2"
  }, /*#__PURE__*/_react["default"].createElement(StyledTypographyComponent, {
    type: "display",
    size: {
      xxs: '5',
      m: '7',
      l: '9'
    }
  }, text))));
}
TextHero.propTypes = propTypes;
TextHero.defaultProps = defaultProps;
var _default = exports["default"] = TextHero;